<script lang="ts">
    import type { MediaImageFragment } from '$gql/graphql.js';
    import { cx } from '$lib/utils/cx.js';
    import { onMount } from 'svelte';
    import { getVideoUrl, mimeTypeIsImage } from './Utils';

    export let media: MediaImageFragment;
    export let isUniqMedia: boolean;

    let loading = true;

    $: src = media.referenceUrl || media.thumbnailUrl;
    $: isImage = media.contentType != null && mimeTypeIsImage(media.contentType);
    $: containerClass = isUniqMedia
        ? isImage
            ? 'w-full'
            : 'w-full aspect-video'
        : 'w-full h-full iframe-child:w-full';

    let containerWidth = 0;

    onMount(() => {
        if (isImage) {
            let img = new Image();
            img.onload = () => {
                loading = false;
            };
            img.src = src;
        }
    });
</script>

<div class={containerClass} bind:clientWidth={containerWidth}>
    {#if loading}
        <div class={'w-full h-full animate-pulse bg-gray-300'}></div>
    {/if}
    {#if isImage}
        <!-- ...restProps on image -->
        <img
            on:load={() => (loading = false)}
            title={media.title}
            alt={media.alt}
            {src}
            class:h-full={!isUniqMedia}
            class={cx(
                'cursor-pointer w-full object-cover object-top',
                loading ? 'opacity-0' : '',
            )}
            style="max-height: {containerWidth * 2}px"
        />
    {:else}
        <iframe
            on:load={() => (loading = false)}
            class={cx(
                isUniqMedia ? 'w-full aspect-video' : 'w-full max-h-full h-full',
                loading ? 'invisible w-0 h-0' : '',
            )}
            title={media.title}
            width="560"
            height="315"
            src={getVideoUrl(media)}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
        />
    {/if}
</div>
